<template>
  <iframe
    title=""
    v-if="shouldShowModal"
    :src="srcIframe"
    class="fixed top-0 left-0 bottom-0 right-0 w-screen h-screen overflow-y-hidden z-50"
  />
</template>

<script>

import configFactory from "@/configFactory";
import {storeToRefs} from "pinia";
import profile from "@/store/profile";
import {useCampaignStore} from "@/store/campaign";
import {computed, onMounted} from "vue";

export default {
  name: "CampaignModal",
  setup() {
    const newConfig = configFactory().getConfig();
    const {isFollower} = profile.state
    const {filename, shouldShowModal} = storeToRefs(useCampaignStore())

    const srcIframe = computed(() => `${newConfig.campaignUrl}/campaigns/promo/${filename.value}/modal.html?follower=${isFollower}`)

    const messageIframe = ({data}) => {
      if (data === 'doNotShowMore') {
        notShow()
      }
      if (data === 'close') {
        close()
      }
      if (data.type === 'NAVIGATE') {
       window.location.href = data.url;
      }
    }

    const close = () => {
      useCampaignStore().closeModal()
    }

    const notShow = () => {
      useCampaignStore().notShow()
    }

    onMounted(() => {
      window.addEventListener('message', messageIframe)
    })

    return {shouldShowModal, srcIframe}
  }
}


</script>
